import React from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SearchInput, SelectInput, TopToolbar, ExportButton } from "react-admin";
import { Link } from "react-router-dom";
import { formatPostalCode, cleanTimeChoices, isOverdue, monthChoices, getNameAndCompanyName } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const InspectHistoryList = () => {

  const CustomerFilters = [
    <SearchInput
      source="q"
      alwaysOn
      placeholder="郵便番号・住所・顧客名"
      inputProps={{ style: { fontSize: '12px' } }}
      sx={{ width: 250 }}
    />,
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>点検月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "点検No": String(record.number).padStart(5, "0"), 
  //       "点検日": record.inspectDate ? new Date(record.inspectDate).toLocaleDateString() : "",
  //       "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //       "顧客名":`${getNameAndCompanyName(record.surname,record.name,record.companyName)}`,
  //       // "清掃予定日": record.exCleaningDate ? new Date(record.exCleaningDate).toLocaleDateString() : "",
  //       // "清掃予定時間": record.exCleaningTime ? cleanTimeChoices.find(choice => choice.id === record.exCleaningTime).name : "",
  //       "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
  //       "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  //       "領収": record.isPay ? "済" : "",
  //       "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
  //       "担当者": record.staffName ?? "",
  //     }

  //   });

  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `点検履歴_` + new Date().toLocaleDateString());
  // };

  const customExporter = (records) => {
    const excelData = records.map(record => ({
      "点検日": record.inspectDate ? new Date(record.inspectDate).toLocaleDateString() : "",
      // "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`,
      // "顧客名": `${getNameAndCompanyName(record.surname, record.name, record.companyName)}`,
      "清掃必要": record.needsCleaning === true ? "必要" : record.needsCleaning === false ? "" : "",
      "採水": record.isSampling === true ? "〇" : record.isSampling === false ? "" : "",
      "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
      "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
      "領収": record.isPay ? "済" : "",
      "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
      "担当者": record.staffName ?? "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 列幅設定
    worksheet['!cols'] = [
      { wch: 12 }, // 点検日
      { wch: 60 }, // 住所
      { wch: 25 }, // 顧客名
      { wch: 10 }, // 清掃必要
      { wch: 10 }, // 採水
      { wch: 15 }, // 請求日
      { wch: 15 }, // 再発行日
      { wch: 8 },  // 領収
      { wch: 15 }, // 領収日
      { wch: 20 }, // 担当者
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '点検履歴');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(blob, `点検履歴_${new Date().toLocaleDateString()}.xlsx`);
  };

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/inspectHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  return (
    <List filters={CustomerFilters} actions={<CustomersActions />} sort={{ field: "inspectDate", order: "ASC" }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        {/* <FunctionField source="number" label="点検No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <DateField source="inspectDate" label="点検日" />
        {/* <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField label="顧客名"
          render={(record) => {
            return <Link to={`/customers-inspect/show/${record.customerId}`}>{`${getNameAndCompanyName(record.surname,record.name,record.companyName)}`}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        /> */}
        <FunctionField
          label="清掃必要"
          render={record => {
            if (record.needsCleaning) return "必要";
            if (!record.needsCleaning) return "";
            return "";
          }}
        />
        <FunctionField
          label="採水"
          render={record => {
            if (record.isSampling) return "〇";
            if (!record.isSampling) return "";
            return "";
          }}
        />
        {/* <DateField source="exCleaningDate" label="清掃予定日" />
        <FunctionField
          label="清掃予定時間"
          render={record => {
            const choice = cleanTimeChoices.find(choice => choice.id === record.exCleaningTime);
            return choice ? choice.name : ""; 
          }}
        /> */}
        <FunctionField
          label=""
          render={record => {
            return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求</>}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <DateField source="invoiceDate" label="請求日" />
        <DateField source="reissueDate" label="再発行日" />
        <FunctionField
          label="領収"
          render={record => {
            return `${record.isPay ? "済" : ""}`;
          }}
        />
        <DateField source="receiptDate" label="領収日" />
        <TextField source="staffName" label="担当者" />
      </Datagrid>
    </List>
  );
}

export default InspectHistoryList;
